import { createSlice } from '@reduxjs/toolkit';
import {
  deleteFaqCategoryAction,
  deleteFaqItemAction,
  getFaqCategoriesAction,
  getFaqItemsAction,
  postFaqCategoryAction,
  postFaqItemAction,
  putFaqCategoryAction,
  putFaqItemAction,
} from './faq.action';

const initialState: Faq.FaqState = {
  isLoading: false,
  error: null,
  categories: [],
  items: {
    items: [],
    limit: 10,
    page: 1,
    totalCount: 0,
    totalPage: 0,
  },
};

const { actions, reducer } = createSlice({
  name: 'faq_slice',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      // Get Categories
      .addCase(getFaqCategoriesAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(getFaqCategoriesAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.categories = action.payload;
      })
      .addCase(getFaqCategoriesAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Post Category
      .addCase(postFaqCategoryAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(postFaqCategoryAction.fulfilled, state => {
        state.isLoading = false;
      })
      .addCase(postFaqCategoryAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })
      // Put Category
      .addCase(putFaqCategoryAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(putFaqCategoryAction.fulfilled, state => {
        state.isLoading = false;
      })
      .addCase(putFaqCategoryAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })
      // Delete Category
      .addCase(deleteFaqCategoryAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(deleteFaqCategoryAction.fulfilled, state => {
        state.isLoading = false;
      })
      .addCase(deleteFaqCategoryAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })
      // Get Items
      .addCase(getFaqItemsAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(getFaqItemsAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items = {
          items: action.payload.records,
          limit: action.payload.pageSize,
          page: action.payload.page,
          totalCount: action.payload.totalRecords,
          totalPage: action.payload.totalPage,
        };
      })
      .addCase(getFaqItemsAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Post Item
      .addCase(postFaqItemAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(postFaqItemAction.fulfilled, state => {
        state.isLoading = false;
      })
      .addCase(postFaqItemAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })
      // Put Item
      .addCase(putFaqItemAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(putFaqItemAction.fulfilled, state => {
        state.isLoading = false;
      })
      .addCase(putFaqItemAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })
      // Delete Item
      .addCase(deleteFaqItemAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(deleteFaqItemAction.fulfilled, state => {
        state.isLoading = false;
      })
      .addCase(deleteFaqItemAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      });
  },
});

export { reducer };
export default actions;
